<div class="tooltip position-{{position}} size-{{size}} position-{{positionX}}">
  <ng-container *ngIf="content">
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </ng-container>
  <ng-container *ngIf="text">{{ text }}</ng-container>
</div>
